<div class="d-flex flex-row align-items-center text-truncate">

  @if (value) {
    <h2>{{value.name}}</h2>
  }
</div>
